import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './agency_v2/Header';
import Footer from './agency_v2/Footer';
import Home from './agency_v2/Home';
import Work from './agency_v2/Work';
import Thinking from './agency_v2/Thinking';
import Brief from './agency_v2/Brief';

export default function AgencyTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F0EBE0]" data-testid="vsp-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`vsp-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'work' && <Work setPage={setPage} />}
          {page === 'thinking' && <Thinking setPage={setPage} />}
          {page === 'brief' && <Brief setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
